<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.Topic"
            placeholder="标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.Source">
            <el-option label="--是否卓悦会--" :value="-1" key="-1"></el-option>
            <el-option label="不是" :value="0" key="0"></el-option>
            <el-option label="是" :value="1" key="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="Topic" label="标题"> </el-table-column>
      <el-table-column
        prop="TotalTime"
        label="时长"
        width="100"
      ></el-table-column>
      <el-table-column prop="" label="是否卓悦会" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Source == 1">是</el-tag>
          <el-tag type="warning" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="是否显示" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsShow == 1">是</el-tag>
          <el-tag type="warning" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="分类" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.CV_Type == 4">学习资源</el-tag>
          <el-tag type="info" v-else-if="scope.row.CV_Type == 0"
            >企业介绍</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.CV_Type == 1"
            >产品介绍</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.CV_Type == 2"
            >活动录播</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.CV_Type == 3"
            >案例研究</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.CV_Type == 6"
            >广告视频</el-tag
          >
          <el-tag type="warning" v-else>其他视频</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Weight" label="权重" width="100"></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="添加时间"
        width="180"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="200"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            style="padding-left: 10px"
            v-for="item in tableButtonList"
            v-bind:key="item.id"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增编辑 -->
    <el-dialog
      title="新增/编辑"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="Topic" label="主标题">
          <el-input
            placeholder="主标题"
            v-model="ruleForm.Topic"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否卓悦会" prop="Source">
          <el-radio-group v-model="ruleForm.Source">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Cover" label="上传图片">
          <div style="display: flex; align-items: center">
            <div class="picDiv" v-if="ruleForm.Cover">
              <img
                :src="
                  ruleForm.Cover +
                  '?x-oss-process=image/resize,h_200,w_360,m_fixed'
                "
              />
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload"
                v-model="fileList"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload"
                @on-update="handleOnUpdate"
                :accept="accept"
                color="#1890ff"
              />
              <span style="font-size: 12px">图片尺寸：360*200（宽*高）</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="分类" prop="CV_Type">
          <el-radio-group v-model="ruleForm.CV_Type">
            <el-radio :label="4">学习资源</el-radio>
            <el-radio :label="2">活动录播</el-radio>
            <el-radio :label="1">产品介绍</el-radio>
            <el-radio :label="3">案例研究</el-radio>
            <el-radio :label="0">企业介绍</el-radio>
            <el-radio :label="6">广告视频</el-radio>
            <el-radio :label="5">其他视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Weight" label="权重">
          <el-input
            placeholder="权重"
            v-model="ruleForm.Weight"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="IsShow">
          <el-radio-group v-model="ruleForm.IsShow">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            clearable
            ref="cautocomplete"
            style="width: 100%"
            highlight-first-item
            v-model="search"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
            @clear="clearSearch"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="视频列表">
          <el-table-draggable>
            <el-table
              row-key="VideoIDStr"
              :data="ruleForm.VideoList"
              style="max-height: 300px; overflow-y: scroll"
            >
              <el-table-column prop="CV_Topic" label="名称"></el-table-column>
              <el-table-column
                prop="CV_VideoTime"
                label="时间"
                width="100"
              ></el-table-column>
              <!-- <el-table-column prop="CV_State" label="状态" width="100"
                ><template slot-scope="scope">
                  <el-tag type="info" v-if="scope.row.CV_State == 0"
                    >审核中</el-tag
                  >
                  <el-tag type="success" v-else-if="scope.row.CV_State == 1"
                    >审核通过</el-tag
                  >
                  <el-tag type="warning" v-else>审核未通过</el-tag>
                </template></el-table-column
              > -->
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="delVideo(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-table-draggable>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import ElTableDraggable from 'el-table-draggable'
import UploadPan from '@/components/Upload/index'
import {
  getVideoCoursePageList,
  getVideoCourseInfo,
  addOrUpdVideoCourse,
  getVideoListByTopic,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    const checkArray = (rule, value, cb) => {
      if (value.length > 0) {
        return cb()
      }
      cb(new Error('请添加视频列表'))
    }
    return {
      search: '',
      fileList: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
      listLoading: false,
      topButtonList: [],
      tableButtonList: [],
      editLoading: false,
      filters: {
        Topic: '',
        Source: -1,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      addFormVisible: false, // 新增弹框
      // 新增弹窗数据
      ruleForm: {
        IdStr: '',
        Topic: '',
        Source: -1,
        IsShow: -1,
        Cover: '',
        CV_Type: -1,
        Weight: 0,
        VideoList: [],
        TotalTime: '',
      },
      rules: {
        Topic: [{ required: true, message: '主标题', trigger: 'blur' }],
        VideoList: [
          {
            required: true,
            message: '请添加视频列表',
            trigger: 'blur',
          },
          {
            // 通过validator 进行自定义校验规则
            validator: checkArray,
            trigger: 'blur',
          },
        ],
        Cover: [{ required: true, message: '请上传封面', trigger: 'blur' }],
        Source: [
          { required: true, message: '请选择是否卓悦会', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请选择是否卓悦会' },
        ],
        CV_Type: [
          { required: true, message: '请选择分类', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请选择分类' },
        ],
        IsShow: [
          { required: true, message: '请选择是否显示', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请选择是否显示' },
        ],
        Weight: [
          { required: true, message: '请输入权重', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请输入权重' },
        ],
      },
    }
  },
  components: {
    UploadPan,
    ElTableDraggable,
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 新增客户用户
    handleAdd() {
      this.addOrUpd()
    },

    handleEdit() {
      getVideoCourseInfo(this.currentRow.IdStr).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
        }
      })
      this.addOrUpd()
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getTotalTime()
          addOrUpdVideoCourse(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.addFormVisible = false
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
      this.ruleForm.Id = 0
      this.ruleForm.IdStr = ''
      this.ruleForm.TotalTime = ''
      this.ruleForm.VideoList = []
      this.search = ''
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getVideoCoursePageList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      console.log('handleOnUpdate')
      console.log(obj)
      // ?x-oss-process=image/resize,h_200,w_360,m_fixed
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.Cover = url
    },
    addOrUpd() {
      this.addFormVisible = true
    },
    querySearchAsync(queryString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        getVideoListByTopic(queryString).then((res) => {
          if (res.data.success) {
            const list = res.data.response
            cb(list)
          }
        })
      }, 1500 * Math.random())
    },

    handleSelect(item) {
      var index = this.ruleForm.VideoList.findIndex(
        (a) => a.VideoIDStr == item.VideoIDStr
      )
      if (index == -1) {
        this.ruleForm.VideoList.push(item)
        this.clearSearch()
      }
    },
    clearSearch() {
      this.$refs.cautocomplete.activated = true
      // or this.$refs.cautocomplete.handleFocus() // 也ok
      this.$emit('clear')
      this.search = ''
    },
    addVideo() {},
    delVideo(row) {
      this.ruleForm.VideoList = this.ruleForm.VideoList.filter((item) => {
        return item.VideoIDStr != row.VideoIDStr
      })
    },
    getTotalTime() {
      var totalMins = 0
      var totalSecs = 0
      this.ruleForm.VideoList.forEach((a) => {
        var strings = a.CV_VideoTime.split(':')
        console.log(strings)
        var min = strings[0]
        var sec = strings[1]
        totalMins += parseInt(min)
        totalSecs += parseInt(sec)
      })
      var mins = totalMins + parseInt(totalSecs / 60)
      var secs = totalSecs % 60
      var videoTime =
        mins.toString().padStart(2, '0') +
        ':' +
        secs.toString().padStart(2, '0')
      this.ruleForm.TotalTime = videoTime
    },
  },
  mounted() {
    this.handleQuery()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}

.editor-upload-btn {
  z-index: 3000 !important;
}
.picDiv {
  width: 360px;
  height: 200px;
  border: 1px solid grey;
}
</style>
